import { render, staticRenderFns } from "./DividendsDetails.vue?vue&type=template&id=1a5f3823&scoped=true"
import script from "./DividendsDetails.vue?vue&type=script&lang=js"
export * from "./DividendsDetails.vue?vue&type=script&lang=js"
import style0 from "./DividendsDetails.vue?vue&type=style&index=0&id=1a5f3823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f3823",
  null
  
)

export default component.exports